import React from 'react'
import { observer } from 'mobx-react'

const UILoadingInline = ({ loading, message, children }) =>
  <React.Fragment>
    {loading ? message || 'carregando...' : children}
  </React.Fragment>

export default observer(UILoadingInline)
